export const googleMapsApiKey = "AIzaSyAGcFXJ3O_DVFPNzawbnByqIy-bpODf1io";
// export const mapContainerSettings = {
//   key: googleMapsApiKey,
//   libraries: ['places', 'drawing'],
//   language: 'cs',
//   region: 'cs'
// };
